import React from 'react';
import {
  ProcessSection,
  SectionHeading,
  ProcessGrid,
  ProcessItem,
  ProcessNumber,
} from './HowItWorks.styles';

const HowItWorks = () => {
  return (
    <ProcessSection>
      <SectionHeading $center>
        <p className="eyebrowHeader">Simple to Get Started</p>

        <h2>Company Training in Four Steps</h2>

        <p>
          Build your company account, add your employees, and start assigning
          the safety training your team needs.
        </p>
      </SectionHeading>

      <ProcessGrid>
        <ProcessItem>
          <ProcessNumber>01</ProcessNumber>
          <h3>Create Your Company Account</h3>
          <p>
            Register your business and create the company account your training
            will be managed through.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>02</ProcessNumber>
          <h3>Add Your Employees</h3>
          <p>
            Build your employee list so training can be purchased and assigned
            to the right people.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>03</ProcessNumber>
          <h3>Choose Their Training</h3>
          <p>
            Select from available online safety courses and assign training to
            the employees who need it.
          </p>
        </ProcessItem>

        <ProcessItem>
          <ProcessNumber>04</ProcessNumber>
          <h3>Track Completion</h3>
          <p>
            Follow course progress and keep completed training records and
            certificates organized.
          </p>
        </ProcessItem>
      </ProcessGrid>
    </ProcessSection>
  );
};

export default HowItWorks;
